<template>
    <div
        class="group/grid relative flex flex-col items-center justify-between gap-4 rounded border border-gray-800 p-4 accent-primary transition-all"
        :class="{
            'cursor-not-allowed opacity-50': productForm().extraItemIsDisabled(extraId, id, maximumSelectionQuantity),
            'cursor-pointer': !productForm().extraItemIsDisabled(extraId, id, maximumSelectionQuantity)
        }">
        <div class="absolute inset-0 z-30 bg-transparent" @click="proxyExtraItemCheckedLogic()" />
        <div class="flex w-full justify-start gap-4">
            <FormKit type="group" :name="id">
                <FormKit
                    v-model="productForm().currentProductWithSelectedExtras.extras[extraId].items[id].selected"
                    type="checkbox"
                    :legend="title"
                    name="selected"
                    :disabled="productForm().extraItemIsDisabled(extraId, id, maximumSelectionQuantity)"
                    :classes="{
                        outer: {
                            'gap-4': false
                        },
                        wrapper: {
                            'flex': false,
                            'p-4': false,
                            'w-full': false,
                            'cursor-pointer': false
                        },
                        label: {
                            'flex': false,
                            'justify-between': false
                        },
                        decorator: {
                            'lg:group-hover/grid:border-gray-400': !productForm().extraItemIsDisabled(extraId, id, maximumSelectionQuantity)
                        }
                    }"
                    @click="productForm().extraItemCheckedLogic(extraId, id, maximumSelectionQuantity)"
                />
                <slot />
            </FormKit>
        </div>
        <div
            v-if="image && image.path"
            class="flex max-w-32 shrink flex-col items-center justify-between gap-2 text-center"
        >
            <div
                class="w-full overflow-hidden rounded"
            >
                <NuxtImg
                    :src="image?.path"
                    class="h-auto cursor-pointer overflow-hidden rounded object-contain"
                    :class="!cloudflareImages ? 'h-full object-cover' : 'h-auto object-contain'"
                    loading="lazy"
                    fit="contain"
                    width="144"
                    height="144" />
            </div>
        </div>
        <div class="flex max-w-32 shrink flex-col items-center justify-between gap-2 text-center">
            <span
                class="select-none text-base font-bold text-gray-700 "
                :class="{
                    'group-hover/grid:text-primary': !productForm().extraItemIsDisabled(extraId, id, maximumSelectionQuantity)
                }">
                {{ title }}
            </span>
            <span
                v-if="showPrices && price"
                class="select-none text-sm font-bold text-gray-700"
                :class="{
                    'lg:group-hover/grid:text-primary': !productForm().extraItemIsDisabled(extraId, id, maximumSelectionQuantity)
                }">
                {{ currencyFormat(price) }}
            </span>
            <Icon
                v-if="props.description || props.allergies"
                class="absolute right-3 top-3 z-40 text-2xl text-black" :icon="IconInfo" :auto-align="false"
                @click="productForm().setExtraDetailsInfo(props)"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ItemProps } from '~/types/local-types'
    import IconInfo from '@/assets/icons/info.svg'
    import Icon from '~/components/Icon.vue'
    import { productForm } from '~/store/productForm'
    // TODO: Make the entire extrasItem clickable between the checkbox and the stepNumber
    import { currencyFormat } from '~/utils/currency-utils'
    const props = defineProps<ItemProps>()
    const { public: { cloudflareImages } } = useRuntimeConfig()
    function proxyExtraItemCheckedLogic () {
        if (!productForm().extraItemIsDisabled(props.extraId, props.id, props.maximumSelectionQuantity)) {
            productForm().extraItemCheckedLogic(props.extraId, props.id, props.maximumSelectionQuantity)
        }
    }
</script>
